import { Navigate, Outlet } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { useAppSelector } from "@/redux/hooks";
import { activeOperatorSelector } from "@/redux/slices/operator/selectors";

/**
 * Route guard that ensures signup is enabled for the operator
 * Uses the same conditions as GeneralHeader's signUpEnabled check
 */
export const RequireSignupEnabled = () => {
  const operator = useAppSelector(activeOperatorSelector);

  // Still loading operator data
  if (!operator) {
    return <Loading />;
  }

  // Check if signup is enabled using same logic as GeneralHeader
  const signUpEnabled = operator.singleTenant;

  if (!signUpEnabled) {
    // Redirect to login if signup is not enabled
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
